module.exports = __webpack_public_path__ + "img/fun1.8523aac7.png";